import { alert } from 'store/alert';
import { Holiday } from 'domain/Holiday';
import { AddAlertAction } from 'store/alert/types';
import { ThunkCommandFactory } from '../types';
import * as actions from './actions';
import {
  SetHolidayListLoadingAction, AddHolidayAction, RemoveHolidayAction,
  UpdateHolidayAction, RefreshHolidayListAction,
} from './types';

export const addHoliday:
ThunkCommandFactory<Holiday, AddAlertAction | AddHolidayAction> = (holiday) => (dispatch, state, client) => {
  const { tenantId } = holiday;
  return client.post<Holiday>(`/tenant/${tenantId}/holiday/add`, holiday).then((newHoliday) => {
    if (!newHoliday) {
      dispatch(alert.showErrorMessage('addHolidayError'));
      return;
    }
    dispatch(alert.showSuccessMessage('addHoliday',));
    dispatch(actions.addHoliday(newHoliday));
  });
};

export const removeHoliday:
ThunkCommandFactory<Holiday, AddAlertAction | RemoveHolidayAction> = (holiday) => (dispatch, state, client) => {
  const { tenantId } = holiday;
  const holidayId = holiday.id;
  return client.delete<boolean>(`/tenant/${tenantId}/holiday/${holidayId}`).then((isSuccess) => {
    if (isSuccess) {
      dispatch(alert.showSuccessMessage('removeHoliday',));
      dispatch(actions.removeHoliday(holiday));
    } else {
      dispatch(alert.showErrorMessage('removeHolidayError',));
    }
  });
};

export const updateHoliday:
ThunkCommandFactory<Holiday, AddAlertAction | UpdateHolidayAction> = (holiday) => (dispatch, state, client) => {
  const { tenantId } = holiday;
  return client.post<Holiday>(`/tenant/${tenantId}/holiday/update`, holiday).then((updatedHoliday) => {
    if (!updatedHoliday) {
      dispatch(alert.showErrorMessage('addHolidayError'));
      return;
    }
    dispatch(alert.showSuccessMessage('updateHoliday', { id: holiday.id }));
    dispatch(actions.updateHoliday(updatedHoliday));
  });
};

export const refreshHolidayList:
ThunkCommandFactory<void, RefreshHolidayListAction |
SetHolidayListLoadingAction> = () => (dispatch, state, client) => {
  const tenantId = state().tenantData.currentTenantId;
  dispatch(actions.setIsHolidayListLoading(true));
  return client.get<Holiday[]>(`/tenant/${tenantId}/holiday/`).then((holidayList) => {
    if (!holidayList) {
      return;
    }
    dispatch(actions.refreshHolidayList(holidayList));
    dispatch(actions.setIsHolidayListLoading(false));
  });
};
